import React from 'react';
import {makeStyles, createStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => createStyles({
  tenantName: {
    marginRight: '2rem',
    marginTop: '4rem',
    width: 'auto',
    float: 'right',
    [theme.breakpoints.down('sm')]: {
      marginTop: 0,
    },
    "& .MuiTypography-h4": {
      [theme.breakpoints.down('sm')]: {
        fontSize: '20px !important',
      },
    },
    "& .MuiTypography-h6": {
      [theme.breakpoints.down('sm')]: {
        fontSize: '16px !important',
      },
    },
  },
  reviewWrap: {
    position: 'relative',
    "& .slick-list": {
      overflow: 'visible',
    },
    "& .slick-thumb .slick-active img": {
      border: 'solid 4px ' + theme.palette.success.main,
    },
    "& hr": {
      borderBottom: 'solid 2px #c4c4c4',
      borderTop: 0,
    },
    "& svg": {
      marginLeft: '4rem',
      [theme.breakpoints.down('sm')]: {
        marginLeft: 0,
        width: 20,
      },
    },
  },
  tenantLocation: {
    fontSize: 22,
  },
  reviewDesc: {
    textAlign: 'center',
    fontSize: '32px !important',
    lineHeight: 1.2,
    padding: '3rem 3rem 1rem',
    fontWeight: 300,

    [theme.breakpoints.down('sm')]: {
      fontSize: '16px !important',
      padding: '0 1rem',
    },
    [theme.breakpoints.up('md')]: {
      // position: 'absolute',
      // left: '50%',
      // top: '50%',
      // transform: 'translate(-50%, -50%)',
      // maxWidth: '65%',
      // width: 895,
    },
  },
  mainImage: {
    borderRadius: '100%',
    width: '190px !important',
    height: '190px !important',
    zIndex: 20,
    objectFit: 'cover',
    objectPosition: 'center',
    [theme.breakpoints.down('sm')]: {
      margin: '2rem auto',
      display: 'block',
      bottom: '-2rem',
    },
    [theme.breakpoints.up('md')]: {
      // position: 'absolute',
      // right: '0',
      // top: '50%',
      // transform: 'translateY(-50%)',
    },
  },
}));
// To override/merge styles in CarouselHOC:
const useSliderStyles = makeStyles((theme) => ({
  galleryImage: {
    position: 'relative',
    [theme.breakpoints.up('md')]: {
      minHeight: 280,
    },
  },
  thumbnailSliderWrap: {
    maxWidth: 400,
    margin: '0 auto',
    [theme.breakpoints.up('md')]: {
      marginTop: '-60px',
    },
    [`@media only print`]: {
      minHeight: 0,
    },
    //   listStyle: 'none',
    //   textAlign: 'center',
    //   display: 'flex !important',
    //   justifyContent: 'center',
    //   paddingLeft: 0,
    //   clear: 'both',
    "& .slick-slide:hover": {
      cursor: 'pointer',
      "& img": {
        border: 'solid 4px ' + theme.palette.warning.main,
      },
    },
    "& .slick-current img": {
      border: 'solid 4px ' + theme.palette.success.main,
    },
    "& .slick-track": {},
    "& .slick-thumb .slick-active img": {
      border: 'solid 4px ' + theme.palette.success.main,
    },
    //   },
  },
  slickThumbnail: {
    width: '68px !important',
    height: '68px !important',
    minHeight: 'unset !important',
    borderRadius: '100%',
    margin: '0 .5rem',
    border: 'solid 4px white',
    // [theme.breakpoints.up('md')]: {
    //   transform: 'translateY(-5rem)',
    // },
  },
}));

export default function Testimonial(props) {
  const classes = useStyles(props);
  const HOCstyles = useSliderStyles(props);
  let { title, body, name, location } = props.node;

  return (
    <Box my={4} className='tenant-box'>
      <Container className={classes.reviewWrap}>
        <hr />
        <Box py={4}>
          <Grid container>
            <svg width="39" height="29" viewBox="0 0 39 29" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9.7 28.1C8.03333 28.1 6.6 27.8 5.4 27.2C4.2 26.6 3.26667 25.7333 2.6 24.6C1.86667 23.6667 1.3 22.4333 0.9 20.9C0.566667 19.3667 0.4 17.8333 0.4 16.3C0.4 12.9667 1.23333 9.9 2.9 7.1C4.63333 4.23333 7.3 1.96666 10.9 0.299994L11.8 2.09999C9.93333 2.9 8.26667 4.13333 6.8 5.79999C5.33333 7.46666 4.46667 9.16666 4.2 10.9C3.86667 12.3667 3.86667 13.7667 4.2 15.1C5.66667 13.5 7.6 12.7 10 12.7C12.3333 12.7 14.2333 13.4 15.7 14.8C17.1667 16.1333 17.9 18 17.9 20.4C17.9 22.7333 17.1 24.6 15.5 26C13.9667 27.4 12.0333 28.1 9.7 28.1ZM30.3 28.1C28.6333 28.1 27.2 27.8 26 27.2C24.8 26.6 23.8667 25.7333 23.2 24.6C22.4667 23.6667 21.9 22.4333 21.5 20.9C21.1667 19.3667 21 17.8333 21 16.3C21 12.9667 21.8333 9.9 23.5 7.1C25.2333 4.23333 27.9 1.96666 31.5 0.299994L32.4 2.09999C30.5333 2.9 28.8667 4.13333 27.4 5.79999C25.9333 7.46666 25.0667 9.16666 24.8 10.9C24.4667 12.3667 24.4667 13.7667 24.8 15.1C26.2667 13.5 28.2 12.7 30.6 12.7C32.9333 12.7 34.8333 13.4 36.3 14.8C37.7667 16.1333 38.5 18 38.5 20.4C38.5 22.7333 37.7 24.6 36.1 26C34.5667 27.4 32.6333 28.1 30.3 28.1Z" fill="black" />
            </svg>
            <Grid item xs={12}>
              <div className={HOCstyles.galleryImage}>
                <Box align="center">
                  <Typography variant="h1" align="center" component="p" color="primary" gutterBottom><strong>{title}</strong></Typography>
                  {body?.length > 0 &&
                    <Typography gutterTop component="div" variant="h3" className={`${classes.reviewDesc} description`} dangerouslySetInnerHTML={{ __html: (body) }}></Typography>
                  }
                  <Box className={`${classes.tenantName} tenant-name`}>
                    {name?.length > 0 &&
                      <Typography component="p" variant="h4">{name}</Typography>
                    }
                    {location?.length > 0 &&
                      <Typography component="p" variant="h6" className={classes.tenantLocation}>{location}</Typography>
                    }
                  </Box>
                </Box>
              </div>
            </Grid>
          </Grid>
        </Box>
        <hr />
      </Container>
    </Box>
  );
}
